<template>
  <div class="invoice">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>Home</BreadcrumbItem>
          <BreadcrumbItem>CMEF SmartLead Manager</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">CMEF SmartLead Manager</div>
      </div>
    </div>
    <div class="invoice-content" v-if="type == 1" style="padding: 30px 30px">
      <!-- <Form
        ref="formInline"
        :model="formInline"
        :rules="ruleInline"
        label-position="right"
        :label-width="20"
        @submit.native.prevent
      >
        <FormItem prop="email">
          <Input
            style="width:400px;"
            type="email"
            placeholder="请输入你的邮箱完成登录验证"
            v-model="formInline.email"
          />
        </FormItem>
        <FormItem>
          <Button
            type="primary"
            @click="handleSubmit('formInline')"
            style="width: 154px;height:36px;"
            :loading="loading"
          >去开通/修改信息</Button>
        </FormItem>
      </Form> -->
      <Button
        type="primary"
        @click="handleSubmit('formInline')"
        style="width: 300px; height: 36px"
        :loading="loading"
        >Go to activate/modify information</Button
      >
      <!-- <div class="hint">
            <div>Kind tips:</div>
            <div>1. CMEF Exhibition Communication is a tool specially designed for CMEF exhibitors to collect exhibition audience data and help companies conduct post-exhibition analysis.</div>
            <div>2. When filling in the following information, please ensure that the user is a person confirmed by the company, and that the information is true and valid. The right to use is not allowed to be sold or transferred, and the organizer reserves the right not to provide post-exhibition data if there are any deficiencies.</div>
            <div>3. The main opener’s application requires uploading instructions stamped with the company’s official seal. Please prepare this in advance before applying.</div>
          </div> -->
    </div>
    <div v-if="type == 2" class="illustrate">
      <div>
        Attention: Please complete this form carefully and accurately. The email
        address of the main contact person will be used for receiving enterprise
        data. Please ensure that it is an employee of the enterprise. Once the
        email address is confirmed, a stamped explanation must be uploaded for
        modification.
      </div>
      <div>
        Disclaimer: The organizer shall not be held responsible for any data
        leakage caused by factors due to the enterprise’s own problems such as
        incorrect input of the account email, transfer of the email of the main
        contact or collector is not an employee of the company.
      </div>
    </div>
    <div class="invoice-content" v-if="type == 3">
      <!-- <scan-revise :infoList="datas"></scan-revise> -->
      <scan-revise :infoList="datas"></scan-revise>
    </div>
    <div class="invoice-content" v-if="type == 4">
      <scan-success></scan-success>
    </div>
    <iModal
      title="Kind tips:"
      v-model="hihtModel"
      class-name="vertical-center-modal"
      width="1000px"
      :mask-closable="false"
    >
      <div class="hint">
        <div>
          1. CMEF Exhibition Communication is a tool specially designed for CMEF
          exhibitors to collect exhibition audience data and help companies
          conduct post-exhibition analysis.
        </div>
        <div>
          2. When filling in the following information, please ensure that the
          user is a person confirmed by the company, and that the information is
          true and valid. The right to use is not allowed to be sold or
          transferred, and the organizer reserves the right not to provide
          post-exhibition data if there are any deficiencies.
        </div>
        <div>
          3. The main opener’s application requires uploading instructions
          stamped with the company’s official seal. Please prepare this in
          advance before applying.
        </div>
      </div>

      <div slot="footer">
        <Button type="primary" @click="handleSubmitReject()">Sure</Button>
        <Button @click="hihtModel = false">Cancel</Button>
      </div>
    </iModal>
  </div>
</template>
  
  <script>
import { mapGetters, mapActions } from "vuex";
import scanRevise from "./components/exhibition-scan-revise.vue";
import scanSuccess from "./components/exhibition-scan-photo.vue";
import { validator } from "@/other/validatorEn";
export default {
  name: "exhibition-scan",
  components: {
    scanRevise,
    scanSuccess,
  },
  data() {
    return {
      formInline: {
        email: "",
      },
      type: 1,
      loading: false,
      hihtModel: false,
      ruleInline: {
        email: validator.email,
      },
      startTime: "",
      endTime: "",
      datas: {},
    };
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      joinInfo: "loginModule/getJoinInfo",
      exhibition: "loginModule/getExhibition",
    }),

    header() {
      return this.$store.state.header;
    },
  },
  created() {
    // this.type = 3
    this.timeNow();
  },
  methods: {
    ...mapActions({
      isEmailExist: "exhibitionScan/isEmailExist",
      GetAllContactPerson: "exhibitionScan/GetAllContactPerson",
      getcontacttime: "hostSetModule/getcontacttime",
    }),

    async timeNow() {
      let timer = await this.getcontacttime(this.exhibition.id);
      if (timer.time) {
        this.startTime = timer.time.startTime;
        this.endTime = timer.time.endTime;
      }
    },
    timerShow() {
      let startTime = new Date(this.startTime);
      let endTime = new Date(this.endTime);
      let currentTime = new Date();
      if (
        this.startTime &&
        this.endTime &&
        currentTime >= startTime &&
        currentTime <= endTime
      ) {
        return true;
      } else {
        this.$Message.warning("展讯通申请暂未开启，请耐心等待~");
        return false;
      }
    },
    async handleSubmit(name) {
      let timer = this.timerShow();
      if (!timer) {
        return;
      }
      this.hihtModel = true;
      return;
      let valid = await this.validForm(name);
      if (!valid) return;
      this.loading = true;

      let req = {
        id: this.company.id,
        email: this.formInline.email,
      };
      let res = await this.isEmailExist(req);
      if (res.item1 == "empty") {
        let req1 = {
          id: this.company.id,
          email: this.formInline.email,
        };
        this.datas = req1;
        this.loading = false;
        this.type = 3;
      } else if (res.item1 == "error") {
        this.$Message.warning(res.item2);
        this.loading = false;
      } else if (res.item1 == "exist") {
        let req1 = {
          id: this.company.id,
          email: this.formInline.email,
        };
        this.datas = req1;
        this.loading = false;
        this.type = 3;
      }
    },
    handleSubmitReject() {
      this.type = 3;
      this.hihtModel = false;
    },
    validForm(name) {
      console.log(name);
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate((valid) => {
          console.log(valid);
          resolve(valid);
        });
      });
    },
  },
};
</script> 
  <style lang="scss" scoped>
.invoice {
  .header-tool {
    min-height: 90px;
  }
  &-content {
    min-width: 800px;
    margin: 15px;
    padding: 0;
    min-height: 500px;
    background: #fff;
    padding-bottom: 190px;
  }
  .invoice-tip {
    line-height: 34px;
    padding-left: 150px;
    color: #ff0000;
    span {
      &:hover {
        cursor: pointer;
      }
    }
  }
}
.illustrate {
  margin: 10px 15px 0;
  color: #ff0000;
}
.hint {
  // color: #ff0000;
  margin: 30px 0;
  div {
    margin-top: 10px;
    font-size: 18px;
    // text-indent: 2em;
  }
  div:nth-child(1) {
    text-indent: 0em;
    // margin-top: 40px;
  }
}
</style>